module.exports = __webpack_public_path__ + "img/chimalhuacan.cfd1dd04.jpg";